// extracted by mini-css-extract-plugin
export default {"layout":"BonusWithGamesPopup__layout--1xZ","game":"BonusWithGamesPopup__game--2jI","bonusGamesSlider":"BonusWithGamesPopup__bonusGamesSlider--SRk"};